module.exports = __webpack_public_path__ + "static/media/loginGraphic.c581414c.jpg";